export default __webpack_public_path__ + "static/media/apply-job.05d9cff9.svg";